export const sidebarStyles: Record<string, React.CSSProperties> = {
  sidebar: {
    width: "var(--sidebar-width)",
    height: "100vh",
    position: "fixed",
    top: 0,
    left: 0,
    display: "flex",
    flexDirection: "column",
    borderRight: "1px solid var(--color-border)",
    background: "var(--color-bg)",
    transition: "width 160ms ease",
  },
  logo: {
    height: "var(--header-height)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 12px 0 20px",
    fontWeight: 700,
    fontSize: 16,
    borderBottom: "1px solid var(--color-border)",
  },
  collapseBtn: {
    display: "inline-grid",
    placeItems: "center",
    width: 32,
    height: 32,
    border: "1px solid var(--color-border)",
    borderRadius: 6,
    color: "var(--color-text-secondary)",
    background: "var(--color-bg)",
    fontSize: 22,
    lineHeight: 1,
  },
  nav: {
    flex: 1,
    overflowY: "auto",
    padding: "8px 0",
  },
  navLink: {
    display: "flex",
    alignItems: "center",
    padding: "8px 20px",
    fontSize: 14,
    color: "var(--color-text)",
    textDecoration: "none",
    borderRadius: 0,
  },
  navLinkActive: {
    background: "var(--color-bg-hover)",
    fontWeight: 600,
  },
  compactNavLink: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 40,
    height: 36,
    margin: "2px auto",
    fontSize: 13,
    color: "var(--color-text)",
    textDecoration: "none",
    borderRadius: 6,
    fontWeight: 700,
  },
  navGroupLabel: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    padding: "8px 20px",
    fontSize: 11,
    color: "var(--color-text-secondary)",
    textTransform: "uppercase" as const,
    fontWeight: 600,
  },
  compactNavGroupLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 40,
    height: 34,
    margin: "2px auto",
    borderRadius: 6,
    color: "var(--color-text-secondary)",
    fontSize: 11,
    fontWeight: 700,
    textTransform: "uppercase" as const,
  },
  navContent: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    minWidth: 0,
  },
  navIcon: {
    display: "inline-grid",
    placeItems: "center",
    width: 22,
    height: 22,
    borderRadius: 6,
    background: "var(--color-bg-hover)",
    color: "var(--color-text-secondary)",
    fontSize: 11,
    fontWeight: 700,
    flex: "0 0 auto",
  },
  navText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  navChildren: { paddingLeft: 12 },
  navChildLink: {
    display: "block",
    padding: "6px 20px",
    fontSize: 14,
    color: "var(--color-text)",
    textDecoration: "none",
  },
  footer: {
    padding: "12px 20px",
    borderTop: "1px solid var(--color-border)",
  },
  userEmail: {
    fontSize: 12,
    color: "var(--color-text-secondary)",
    marginBottom: 8,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  logoutBtn: {
    fontSize: 13,
    color: "var(--color-danger)",
    padding: 0,
  },
  localeBtn: {
    fontSize: 12,
    color: "var(--color-text-secondary)",
    padding: "4px 0",
    marginTop: 4,
    textAlign: "left" as const,
  },
  compactFooterBtn: {
    display: "grid",
    placeItems: "center",
    width: 36,
    height: 30,
    margin: "4px auto",
    borderRadius: 6,
    color: "var(--color-text-secondary)",
    fontSize: 13,
  },
};
